/** Download tabular data as CSV */

function escCell(v) {
  const s = String(v ?? '');
  if (/[",\n\r]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
}

export function downloadCsv(filename, headers, rows) {
  const lines = [
    headers.map(escCell).join(','),
    ...rows.map((row) => headers.map((h) => escCell(row[h])).join(',')),
  ];
  const blob = new Blob([`\uFEFF${lines.join('\n')}`], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export function queueToCsvRows(queue) {
  return (queue || []).map((r) => ({
    token: r.token || '',
    patient: r.patientName || r.name || '',
    patientId: r.patientId || '',
    phone: r.patientPhone || '',
    doctor: r.doctor || '',
    status: r.status || '',
    visitDate: r.visitDate || '',
    time: r.appointmentTime || r.time || '',
    visitType: r.visitType || '',
    fee: r.fee ?? '',
    reason: r.reason || '',
    tags: (r.tags || []).join('; '),
  }));
}

export function downloadQueueCsv(queue, dateLabel = 'today') {
  const headers = ['token', 'patient', 'patientId', 'phone', 'doctor', 'status', 'visitDate', 'time', 'visitType', 'fee', 'reason', 'tags'];
  downloadCsv(`op-queue-${dateLabel}.csv`, headers, queueToCsvRows(queue));
}
